const TURNSTILE_TOKEN_KEY = 'weavy_signin_turnstile_token';
export const TURNSTILE_TOKEN_MAX_AGE_MS = 4.5 * 60 * 1000;

interface StoredTurnstileToken {
  token: string;
  createdAt: number;
}

let memoryToken: StoredTurnstileToken | undefined;

export const storeTurnstileToken = (token: string, createdAt = Date.now()): void => {
  memoryToken = { token, createdAt };
  try {
    sessionStorage.setItem(TURNSTILE_TOKEN_KEY, JSON.stringify(memoryToken));
  } catch {
    // The in-memory copy still supports popup sign-in when storage is blocked.
  }
};

export const getTurnstileToken = (now = Date.now()): string | undefined => {
  let storedValue: string | null = null;
  try {
    storedValue = sessionStorage.getItem(TURNSTILE_TOKEN_KEY);
  } catch {
    // Fall back to the in-memory copy below.
  }

  try {
    const stored = storedValue ? (JSON.parse(storedValue) as Partial<StoredTurnstileToken>) : memoryToken;
    if (
      !stored ||
      typeof stored.token !== 'string' ||
      typeof stored.createdAt !== 'number' ||
      now - stored.createdAt >= TURNSTILE_TOKEN_MAX_AGE_MS
    ) {
      clearTurnstileToken();
      return undefined;
    }
    return stored.token;
  } catch {
    clearTurnstileToken();
    return undefined;
  }
};

export const clearTurnstileToken = (): void => {
  memoryToken = undefined;
  try {
    sessionStorage.removeItem(TURNSTILE_TOKEN_KEY);
  } catch {
    // Storage may be unavailable in privacy-restricted browser contexts.
  }
};
